import { render, staticRenderFns } from "./ProductSpecification.vue?vue&type=template&id=4fc8bc97&scoped=true&"
import script from "./ProductSpecification.vue?vue&type=script&lang=js&"
export * from "./ProductSpecification.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecification.vue?vue&type=style&index=0&id=4fc8bc97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc8bc97",
  null
  
)

export default component.exports